import Vue from 'vue'
import axios from 'axios'

import App from './App'
import router from './router'

Vue.config.productionTip = false

Vue.http = axios;
Object.defineProperties(Vue.prototype, {
	http: { get () { return axios; } },
	$http: { get () { return axios; } }
});

Vue.filter('bool', v => v ? 'Yes' : 'No');

/* eslint-disable no-new */
new Vue({
  router,
  ... App
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js